module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hrms-lov-codcomp2"
    }
  }, [_c('div', {
    staticClass: "lov-box clearfix"
  }, [_vm._l((7), function(i) {
    return [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.codcomp[i - 1]),
        expression: "codcomp[i - 1]"
      }],
      ref: 'lovCodcomp' + i,
      refInFor: true,
      staticClass: "lovCodcomp",
      attrs: {
        "type": "text",
        "maxlength": "3",
        "disabled": _vm.disabled
      },
      domProps: {
        "value": (_vm.codcomp[i - 1])
      },
      on: {
        "focusin": function($event) {
          _vm.focusCodcomp = i - 1
        },
        "keyup": [function($event) {
          _vm.checkNextCodcomp(i, $event.target.value)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete"])) { return null; }
          _vm.checkPrevCodcomp(i, $event.target.value)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
          _vm.setInputValue()
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.setInputValue()
        }],
        "change": function($event) {
          _vm.setInputValue()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.codcomp, i - 1, $event.target.value)
        }
      }
    })]
  }), _vm._v(" "), (_vm.disabled) ? _c('button', {
    staticClass: "btn-lov-disable",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('button', {
    staticClass: "btn-lov",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search color-skin"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.descDisp),
      expression: "descDisp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.descInputValue),
      expression: "descInputValue"
    }],
    staticClass: "form-control detail-lov",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.descInputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descInputValue = $event.target.value
      }
    }
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showModal) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_c('i', {
    staticClass: "fa fa-close close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("List of Company")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('hrms-table', {
    attrs: {
      "columns": _vm.columns[_vm.nowLang].popup,
      "data": _vm.filterData(_vm.data),
      "indexDisp": false,
      "isLovTable": true,
      "loadingParentBool": _vm.loadingParentBool,
      "tickEvent": _vm.tickEvent
    },
    on: {
      "setLoadingParentBool": function($event) {
        _vm.loadingParentBool = arguments[0]
      }
    }
  })])], 2)])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-209a17b5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsLovCodcomp2/component.vue
// module id = 3620
// module chunks = 1